import React from 'react'
import type { Listing } from '~/models'

type ListingDescriptionProps = {
  listing?: Listing
  description?: string
  heading?: React.ReactNode
}

export function getListingDescription(listing: Listing) {
  const description = listing.meta.description
  const highlights = listing.meta.highlights

  if (!description && !highlights) {
    return
  }

  const prose = ((description || '') + (highlights || ''))
    .replace('<h4>Description</h4>', '')
    .replace('<h4>Highlights</h4>', '')
    .trim()

  if (!prose || prose == '<p></p>') {
    return
  }

  return prose
}

export function ListingDescription({
  listing,
  description,
  heading = null,
}: ListingDescriptionProps) {
  if (!listing && !description) {
    throw new Error(
      'ListingDescription requires either a listing or description prop'
    )
  }
  if (!description && listing) {
    description = getListingDescription(listing) || undefined
  }
  if (!description || description == 'null') {
    return null
  }

  return (
    <div>
      {heading}
      <div
        className="prose mt-1 max-w-none text-base"
        dangerouslySetInnerHTML={{ __html: description }}></div>
    </div>
  )
}
